export const SearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 16.2921L20.854 20.1461C21.0495 20.3416 21.0495 20.6586 20.854 20.8541C20.6585 21.0496 20.3415 21.0496 20.146 20.8541L16.292 16.9991C13.0517 19.8575 8.12712 19.6264 5.16877 16.477C2.21043 13.3277 2.2875 8.39825 5.34285 5.34291C8.39819 2.28756 13.3276 2.21049 16.477 5.16884C19.6263 8.12718 19.8574 13.0518 16.999 16.2921H17ZM11 18.0001C13.5009 18.0001 15.8117 16.6659 17.0622 14.5001C18.3126 12.3343 18.3126 9.66587 17.0622 7.50006C15.8117 5.33425 13.5009 4.00006 11 4.00006C7.13401 4.00006 4 7.13407 4 11.0001C4 14.8661 7.13401 18.0001 11 18.0001Z"
      fill="currentColor"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 6V18.5C19 19.8807 17.8807 21 16.5 21H7.5C6.11929 21 5 19.8807 5 18.5V6H4.5C4.22386 6 4 5.77614 4 5.5C4 5.22386 4.22386 5 4.5 5H9V4.5C9 3.67157 9.67157 3 10.5 3H13.5C14.3284 3 15 3.67157 15 4.5V5H19.5C19.7761 5 20 5.22386 20 5.5C20 5.77614 19.7761 6 19.5 6H19ZM6 6V18.5C6 19.3284 6.67157 20 7.5 20H16.5C17.3284 20 18 19.3284 18 18.5V6H6ZM14 5V4.5C14 4.22386 13.7761 4 13.5 4H10.5C10.2239 4 10 4.22386 10 4.5V5H14ZM14 9.5C14 9.22386 14.2239 9 14.5 9C14.7761 9 15 9.22386 15 9.5V16.5C15 16.7761 14.7761 17 14.5 17C14.2239 17 14 16.7761 14 16.5V9.5ZM9 9.5C9 9.22386 9.22386 9 9.5 9C9.77614 9 10 9.22386 10 9.5V16.5C10 16.7761 9.77614 17 9.5 17C9.22386 17 9 16.7761 9 16.5V9.5Z"
      fill="currentColor"
    />
  </svg>
);

export const PlusCircleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 12H16.5C16.7761 12 17 12.2239 17 12.5C17 12.7761 16.7761 13 16.5 13H13V16.5C13 16.7761 12.7761 17 12.5 17C12.2239 17 12 16.7761 12 16.5V13H8.5C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12H12V8.5C12 8.22386 12.2239 8 12.5 8C12.7761 8 13 8.22386 13 8.5V12ZM12.5 23C6.701 23 2 18.299 2 12.5C2 6.701 6.701 2 12.5 2C18.299 2 23 6.701 23 12.5C23 18.299 18.299 23 12.5 23ZM12.5 22C17.7467 22 22 17.7467 22 12.5C22 7.25329 17.7467 3 12.5 3C7.25329 3 3 7.25329 3 12.5C3 17.7467 7.25329 22 12.5 22Z"
      fill="currentColor"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 12H18.5C18.7761 12 19 12.2239 19 12.5C19 12.7761 18.7761 13 18.5 13H13V18.5C13 18.7761 12.7761 19 12.5 19C12.2239 19 12 18.7761 12 18.5V13H6.5C6.22386 13 6 12.7761 6 12.5C6 12.2239 6.22386 12 6.5 12H12V6.5C12 6.22386 12.2239 6 12.5 6C12.7761 6 13 6.22386 13 6.5V12Z"
      fill="currentColor"
    />
  </svg>
);

export const EditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.293 18L18.793 6.49998L16.5 4.20698L5 15.707V18H7.293ZM4 18.5V15.5C3.99976 15.3673 4.05229 15.2399 4.146 15.146L16.146 3.14598C16.2398 3.05194 16.3672 2.99908 16.5 2.99908C16.6328 2.99908 16.7602 3.05194 16.854 3.14598L19.854 6.14598C19.948 6.23978 20.0009 6.36715 20.0009 6.49998C20.0009 6.63281 19.948 6.76017 19.854 6.85398L7.854 18.854C7.76005 18.9477 7.6327 19.0002 7.5 19H4.5C4.22386 19 4 18.7761 4 18.5ZM4.5 21C4.22386 21 4 20.7761 4 20.5C4 20.2238 4.22386 20 4.5 20H14.507C14.7831 20 15.007 20.2238 15.007 20.5C15.007 20.7761 14.7831 21 14.507 21H4.5Z"
      fill="currentColor"
    />
  </svg>
);

export const ExclamationIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 13.5C13 13.7762 12.7762 14 12.5 14C12.2239 14 12 13.7762 12 13.5V9.50001C12 9.22387 12.2239 9.00001 12.5 9.00001C12.7762 9.00001 13 9.22387 13 9.50001V13.5ZM12 16H13V17H12V16ZM12.058 3.26601C12.1446 3.10222 12.3147 2.99976 12.5 2.99976C12.6853 2.99976 12.8554 3.10222 12.942 3.26601L21.942 20.266C22.0241 20.421 22.019 20.6077 21.9285 20.7579C21.838 20.9082 21.6754 21.0001 21.5 21H3.50001C3.32462 21.0001 3.16202 20.9082 3.07154 20.7579C2.98106 20.6077 2.97593 20.421 3.05801 20.266L12.058 3.26601ZM4.33001 20H20.67L12.5 4.56901L4.33001 20Z"
      fill="currentColor"
    />
  </svg>
);

export const SignOutIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.707 12L7.854 15.146C8.04951 15.3415 8.04951 15.6585 7.854 15.854C7.65849 16.0495 7.34151 16.0495 7.146 15.854L3.146 11.854C3.05196 11.7602 2.99911 11.6328 2.99911 11.5C2.99911 11.3672 3.05196 11.2398 3.146 11.146L7.146 7.146C7.34151 6.95049 7.65849 6.95049 7.854 7.146C8.04951 7.34151 8.04951 7.65849 7.854 7.854L4.707 11H15.5C15.7761 11 16 11.2239 16 11.5C16 11.7761 15.7761 12 15.5 12H4.707ZM10.5 4C10.2239 4 10 3.77614 10 3.5C10 3.22386 10.2239 3 10.5 3H18.5C19.8807 3 21 4.11929 21 5.5V18.5C21 19.8807 19.8807 21 18.5 21H10.5C10.2239 21 10 20.7761 10 20.5C10 20.2239 10.2239 20 10.5 20H18.5C19.3284 20 20 19.3284 20 18.5V5.5C20 4.67157 19.3284 4 18.5 4H10.5Z"
      fill="currentColor"
    />
  </svg>
);

export const BackIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.27702 11.8334H19.3334C19.7015 11.8334 20 12.1318 20 12.5C20 12.8681 19.7015 13.1666 19.3334 13.1666H6.27702L10.4727 17.361C10.7334 17.6216 10.7334 18.0442 10.4727 18.3049C10.2121 18.5655 9.78944 18.5655 9.52878 18.3049L4.19584 12.9719C4.07046 12.8469 4 12.6771 4 12.5C4 12.3229 4.07046 12.1531 4.19584 12.028L9.52878 6.69508C9.6974 6.52647 9.94316 6.46061 10.1735 6.52233C10.4038 6.58405 10.5837 6.76396 10.6455 6.9943C10.7072 7.22463 10.6413 7.4704 10.4727 7.63901L6.27702 11.8334Z"
      fill="currentColor"
    />
  </svg>
);

export const FilterIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 12.707V18.5C15 18.7043 14.8756 18.888 14.686 18.964L9.686 20.964C9.53196 21.0257 9.35733 21.007 9.21987 20.914C9.08241 20.8211 9.00004 20.6659 9 20.5V12.707L3.146 6.854C3.05229 6.76005 2.99976 6.6327 3 6.5V3.5C3 3.22386 3.22386 3 3.5 3H20.5C20.7761 3 21 3.22386 21 3.5V6.5C21.0002 6.6327 20.9477 6.76005 20.854 6.854L15 12.707ZM14 13H10V19.761L14 18.161V13ZM4 4V6.293L9.707 12H14.293L20 6.293V4H4Z"
      fill="currentColor"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 11.293L16.146 7.14602C16.3415 6.95051 16.6585 6.95051 16.854 7.14602C17.0495 7.34153 17.0495 7.65851 16.854 7.85402L12.707 12L16.854 16.146C17.0495 16.3415 17.0495 16.6585 16.854 16.854C16.6585 17.0495 16.3415 17.0495 16.146 16.854L12 12.707L7.85402 16.854C7.65851 17.0495 7.34153 17.0495 7.14602 16.854C6.95051 16.6585 6.95051 16.3415 7.14602 16.146L11.293 12L7.14602 7.85402C6.95051 7.65851 6.95051 7.34153 7.14602 7.14602C7.34153 6.95051 7.65851 6.95051 7.85402 7.14602L12 11.293Z"
      fill="currentColor"
    />
  </svg>
);
